import { axiosInstance } from "../../Utils/AxiosInstance";

export const GetAllMaterialApi = async () => {
  try {
    const response = await axiosInstance.get(`/Store/Material/GetAll`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const AddMaterialApi = async (data) => {
  try {
    const response = await axiosInstance.post(`/Store/Material/Create`, data);
    return response;
  } catch (error) {
    throw error;
  }
};

export const DeleteMaterialApi = async (id) => {
  try {
    const response = await axiosInstance.delete(`/Store/Material/Delete/${id}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const EditMaterialApi = async (id, data) => {
  try {
    const response = await axiosInstance.put(`/Store/Material/Edit/${id}`, data);
    return response;
  } catch (error) {
    throw error;
  }
};
